// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"s4-z","displaySixCardTiles":"t4-z"};